import ErrorSharpIcon from '@mui/icons-material/ErrorSharp';
import { Box, FormControl, TextField } from '@mui/material';
import { ChangeEvent, forwardRef, useState } from 'react';
import MaskedInput from 'react-text-mask';
import { regexPhone } from '~/components/Input/regex';
import { isValidBrazilianMobile, onlyPhoneDigits } from '~/utils/phoneValidation';
import { containerInput, containerMessage, inputStyle } from '../InputCpf/styles';
import { Message } from '../types';

export const INVALID_PHONE_MESSAGE = 'Digite um celular válido com DDD, ex.: (11) 98765-4321.';

const PhoneMask = forwardRef<HTMLInputElement, React.ComponentProps<typeof MaskedInput>>(function PhoneMask(
  props,
  _ref
) {
  return <MaskedInput {...props} mask={regexPhone} placeholderChar={' '} />;
});

interface Props {
  content?: Message['content'];
  author?: Message['author'];
  Component?: Message['Component'];
  /** Valor digitado (com máscara) e se é um celular BR válido. */
  onPhoneChange?: (phone: string, isValid: boolean) => void;
  defaultValue?: string;
}

/** CORE-1025: input do celular pedido depois do código quando o cadastro não tem telefone. */
export const InputPhone = ({ onPhoneChange, defaultValue = '' }: Props) => {
  const [phone, setPhone] = useState(defaultValue);
  const [error, setError] = useState(false);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value = event.target.value;
    const isValid = isValidBrazilianMobile(value);

    setPhone(value);
    // Só acusa erro depois de o número estar completo, para não piscar vermelho enquanto digita
    setError(!isValid && onlyPhoneDigits(value).length >= 10);
    onPhoneChange?.(value, isValid);
  };

  return (
    <Box>
      <Box sx={() => containerMessage(error)}>
        <FormControl variant="outlined" sx={containerInput}>
          <TextField
            value={phone}
            onChange={handleChange}
            error={error}
            helperText={error ? INVALID_PHONE_MESSAGE : ''}
            type="tel"
            variant="outlined"
            placeholder="Informe seu celular com DDD"
            sx={inputStyle}
            inputProps={{ 'aria-label': 'Celular com DDD' }}
            InputProps={{
              endAdornment: error && <ErrorSharpIcon color="error" />,
              inputComponent: PhoneMask as any
            }}
          />
        </FormControl>
      </Box>
    </Box>
  );
};
